import {connect} from 'react-redux'
import {Loader, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Col, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import {getIdFromProps} from "../../utils/utils";
import AdresyPanel from "../../components/AdresyPanel";
import UzivatelZakladniUdajePanel from "../../components/UzivatelZakladniUdajePanel";
import KartyPanel from "../../components/KartyPanel";
import NastaveniObjednavkyPanel from "../../components/NastaveniObjednavkyPanel";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - detail konkrétního uživatele
 */
class UzivatelPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(subjektActions.fetchUzivatelDetailIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(subjektActions.fetchUzivatelRightsIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(subjektActions.fetchAdresyUzivatelIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(subjektActions.fetchKartyUzivatelIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(subjektActions.fetchSpolecnostiUzivatelIfNeeded(getIdFromProps(this.props)));
    };

    render() {
        const {uzivatelDetail, uzivatelRights, adresyUzivatelList, kartyUzivatelList, spolecnostiUzivatelList, t} = this.props;

        if (!uzivatelRights.fetched || !uzivatelDetail.fetched) {
            return <Loader/>;
        }

        const uzivatel = uzivatelDetail.data;
        const {zpusobDopravaVychozi, zpusobPlatbaVychozi, notifikaceEmail, notifikaceSms} = uzivatel;

        return <AdminPage
                title={uzivatel.zobrazJmeno}
                subtitle={t('user.show', {username: uzivatel.zobrazJmeno})}
                content={<Row>
                    <Col xs={12} sm={6}>
                        <UzivatelZakladniUdajePanel
                            uzivatel={uzivatel}
                            readOnly={!uzivatelRights.data.uzivatelEdit}
                        />
                    </Col>
                    <Col xs={12} sm={6}>
                        <NastaveniObjednavkyPanel
                            nastaveniObjednavky={{
                                zpusobDopravaVychozi,
                                zpusobPlatbaVychozi,
                                notifikaceEmail,
                                notifikaceSms,
                            }}
                            uzivatelId={uzivatel.id}
                            readOnly={!uzivatelRights.data.vychVolbyEdit}
                        />
                    </Col>
                    <Col xs={12} sm={6}>
                        {adresyUzivatelList.fetched ?
                        <AdresyPanel
                            adresyList={adresyUzivatelList.rows}
                            uzivatelId={uzivatel.id}
                            uzivatelMaSpolecnost={spolecnostiUzivatelList.fetched && spolecnostiUzivatelList.rows.length !== 0}
                            readOnly={!uzivatelRights.data.adresaEdit}
                        /> : <Loader/>}
                    </Col>
                    <Col xs={12} sm={6}>
                        {kartyUzivatelList.fetched ?
                        <KartyPanel
                            kartyList={kartyUzivatelList.rows}
                            readOnly={!uzivatelRights.data.kartaEdit}
                        /> : <Loader/>}
                    </Col>
                </Row>}
            />
    }
}

function mapStateToProps(state) {
    return {
        uzivatelDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_DETAIL_AREA),
        uzivatelRights: utils.storeFromArea(state, subjektActions.UZIVATEL_RIGHTS_AREA),
        adresyUzivatelList: utils.storeFromArea(state, subjektActions.UZIVATEL_ADRESY_LIST_AREA),
        kartyUzivatelList: utils.storeFromArea(state, subjektActions.UZIVATEL_KARTY_LIST_AREA),
        spolecnostiUzivatelList: utils.storeFromArea(state, subjektActions.UZIVATEL_SPOLECNOSTI_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(UzivatelPage));

